// extracted by mini-css-extract-plugin
export default {"YouTube":"JsBtl2esp3wRMkoPgIYK"};